import React, { useState, useEffect } from "react";
import Modal from "@mui/material/Modal";
import { makeStyles } from "@mui/styles";
import Box from "@mui/material/Box";
import cssClasses from "./CreateFloorPlan.module.css";
import Close from "../../Components/Icons/Close";
import Button from "../../Subcomponents/Button";
import CustomInput from "../../Subcomponents/CustomInput";

import galleryImg from "../../Assets/Images/Common/gallery.svg";
import ProgressBar from "../../Subcomponents/ProgressBar";
import DropDown from "../../Subcomponents/DropDown";
import { getAllWingsByProjectId, getWingsByProjectId } from "../../Services/SustenanceService";
import { errorTost, offlineToast, successTost } from "../../Services/Toast";
import {
  assignNewFloorPlan,
  getFloorByWingIdAndProjectId,
  updateFloorPlan,
  updateInventoryForFloorPlans,
  uploadFloorPlanImg,
} from "../../Services/FloorPlans";
import { chain, each, sortBy, uniqBy } from "lodash";
import { FloorBlock } from "../../Subcomponents/FloorComponent/FloorComponents";
import { uploadEventBannerImg } from "../../Services/Event";
import { Network } from "@capacitor/network";

const useStyles = makeStyles((theme) => ({
  radioLabel: {
    fontFamily: "Inter-Medium !important",
    fontSize: "1.6rem",
    lineHeight: "2.5rem",
  },
  prefernceNumber: {
    fontFamily: "Inter-Medium",
    fontStyle: "normal",
    fontWeight: 400,
    fontSize: "1.2rem",
    lineHeight: "1.8rem",
    /* identical to box height, or 150% */

    /* Gray/500 */

    color: "#667085",
  },
  wrapperIcons: {
    display: "flex",
    flexDirection: "row",
    alignItems: "flex-start",
    justifyContent: "space-around",
    marginBottom: "2rem",
    position: "relative",
  },
  TextFieldStyle: {
    width: "100%",
    background: "#F2F4F7 !important",
    paddingRight: "0rem !important",
    borderRadius: "10px !important",
    fontSize: "1.6rem !important",
    fontFamily: "Inter-Medium !important",
    lineHeight: "2.4rem !important",
  },
  inputStyle: {
    fontFamily: "Inter-Medium !important",
    paddingRight: "0rem !important",
    fontSize: "1.6rem !important",
    lineHeight: "2.4rem !important",
    background: "#F2F4F7  !important",
    //   border: '1px solid #D0D5DD',
    boxShadow: "0px 1px 2px rgba(16, 24, 40, 0.05)",
    borderRadius: "10px !important",
    border: "1px solid #F2F4F7",
    "& input": {
      fontSize: "1.6rem !important",
      lineHeight: "2.4rem !important",
      color: "#101828 !important",
      padding: "1.3rem 1.4rem",
      border: "none !important",
      boxShadow: "none !important",
    },

    "& input[text]": {
      color: "#101828 !important",
    },
    "& input[input:-internal-autofill-selected]": {
      background: "#F2F4F7 !important",
    },
    "& input[value]": {
      background: "#FFFFF !important",
    },
    "& .MuiOutlinedInput-notchedOutline": {
      border: "none",
    },
    "&.Mui-focused": {
      background: "#FFFFFF !important",
      border: "1px solid #84CAFF !important",
      boxShadow: "0px 1px 2px rgba(16, 24, 40, 0.05), 0px 0px 0px 4px #D1E9FF",
    },
    "&.Mui-error": {
      border: "1px solid red !important",
      boxShadow: "none !important",
    },
  },

  helperText: {
    background: "#FFFFFF !important",
    fontSize: "1.4rem !important",
    margin: "0rem 0 0 0 !important",
    fontFamily: "Inter-Medium !important",
    lineHeight: "1.8rem !important",
    paddingTop: "0.5rem !important ",
  },
  closeIconModal: {
    cursor: "pointer",
    position: "absolute",
    right: "1rem",
    top: "1rem",
  },
  closeIcon: {
    cursor: "pointer",
    position: "absolute",
    right: "0rem",
  },
  title: {
    fontFamily: "Inter-Medium",
    fontStyle: "normal",
    fontWeight: "500",
    fontSize: "3rem",
    lineHeight: "3.8rem",
    color: "#101828",
    marginBottom: "1.8rem",
  },
  subTitle: {
    fontFamily: "Inter-Medium",
    fontStyle: "normal",
    fontWeight: "500",
    fontSize: "1.6rem",
    lineHeight: "2.4rem",
    color: "#667085",
    marginBottom: "3.2rem",
  },
  wrapperButtons: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-between",
    columnGap: "1.2rem",
  },
}));
export default function CreateFloorPlan({
  open,
  handleClose,
  projectId,
  returnRes,
  floorPlanData,
  modalType,
}) {
  const [steps, setSteps] = useState([
    { title: "Create Floor Plan" },
    { title: "Assign Floor Units" },
  ]);
  const [activeStep, setActiveStep] = useState(0);
  const [floorPlanObj, setFloorPlanObj] = useState({
    name: "",
    floorPlanImageUrl: "",
  });
  const [helperText, setHelperText] = useState({
    name: "",
    floorPlanImageUrl: "",
    selectWing: "",
    selectFloor: "",
  });
  const [uploadedFile, setUploadedFile] = useState(null);
  const [allWings, setAllWings] = useState([]);
  const [selectedWing, setSelectedWing] = useState(null);
  const [allFloors, setAllFloors] = useState([]);

  // ??Modal Type is Edit
  useEffect(() => {
    console.log({ floorPlanData });
    if (modalType === "edit") {
      setFloorPlanObj((pre) => {
        pre.name = floorPlanData.name;
        pre.floorPlanImageUrl = floorPlanData.floorPlanImgUrl;
        return { ...pre };
      });
    }
  }, []);

  useEffect(() => {
    if (uploadedFile) {
      document.getElementById("floorImg").src =
        URL.createObjectURL(uploadedFile);
    }
  }, [uploadedFile]);

  useEffect(() => {
    if (activeStep === 0 && uploadedFile) {
      document.getElementById("floorImg").src =
        URL.createObjectURL(uploadedFile);
    }
    if (activeStep === 1) {
      if (modalType === "add") {
        Network.getStatus().then((status) => {
          if (status.connected) {
        getWingsByProjectId(projectId)
          .then((resp) => {
            setAllWings([...resp.data]);
            if (resp.data.length > 0) {
              setSelectedWing(resp?.data[0]?.wingId);
              getFloors(projectId, resp?.data[0]?.wingId);
            }
          })
          .catch((err) => {
            console.log(err);
          });
        }else{
          offlineToast();
        }});
      } else if (modalType === "edit") {
        let obj = [
          {
            wingId: floorPlanData.wingId,
            wingName: floorPlanData.wingName,
          },
        ];
        setAllWings(obj);
        setSelectedWing(floorPlanData.wingId);
        floorPlanData.Inventory.forEach((el) => {
          el.isSelected = true;
          el.showCheckBox = true;
        });
        setAllFloors(
          uniqBy(sortBy([...floorPlanData.Inventory], "floorNo"), "floorNo")
        );
        console.log({ allFloors });
      }
    }
  }, [activeStep]);

  const classes = useStyles();
  function closeModal() {
    handleClose();
  }
  function convertImageFileToWebpFile(file) {
    return new Promise((resolve, reject) => {
      const image = new Image();
      image.onload = () => {
        const canvas = document.createElement("canvas");
        canvas.width = image.naturalWidth;
        canvas.height = image.naturalHeight;
        canvas.getContext("2d").drawImage(image, 0, 0);
        canvas.toBlob((blob) => {
          let myFile = new File([blob], "my-new-group-image.webp", {
            type: blob.type,
          });
          resolve(myFile);
        }, "image/webp");
      };
      image.crossOrigin = "anonymous";
      image.src = URL.createObjectURL(file);
    });
  }

  function validateCreateFloorPlan() {
    let validateFlag = 0;
    if (floorPlanObj.name === "") {
      setHelperText((pre) => {
        pre.name = "Please enter floor plan name";
        return { ...pre };
      });
      validateFlag = 1;
    }
    if (modalType === "add") {
      if (uploadedFile === null) {
        setHelperText((pre) => {
          pre.floorPlanImageUrl = "Please upload floor plan image";
          return { ...pre };
        });
        validateFlag = 1;
      }
    }

    return validateFlag;
  }

  function save() {
    let checkIfNoneIsSelected = allFloors.filter(
      ({ isSelected }) => isSelected === true
    );
    console.log({ checkIfNoneIsSelected });
    // ??Modal Type add
    if (modalType === "add") {
      
      if (checkIfNoneIsSelected.length === 0) {
        errorTost("Please Select Floor");
      } else {
        Network.getStatus().then((status) => {
          if (status.connected) {
        assignNewFloorPlan(floorPlanObj.name)
          .then((newFloorPlan) => {
            console.log({ newFloorPlan });
            console.log(uploadedFile, floorPlanObj.floorPlanImageUrl);
            convertImageFileToWebpFile(uploadedFile)
              .then((file) => {
                console.log(file);
                uploadFloorPlanImg(newFloorPlan.data[0].floorPlanId, file)
                  .then((res) => {
                    console.log("res", res);
                    // let floorPlanImageUrl = `floorplans/${newFloorPlan.data[0].floorPlanId}.webp`;

                    updateFloorPlan(newFloorPlan.data[0].floorPlanId, {
                      floorPlanImgUrl: `floorplans/${newFloorPlan.data[0].floorPlanId}.webp`,
                    })
                      .then((r) => {
                        console.log("r", r);
                        // ??Update On Inventory table update floorPlanId
                        let flag = false;
                        let count = 0;
                        allFloors.forEach((floor) => {
                        
                          count = count + 1;
                          if (floor.isSelected) {
                            console.log(floor);
                            updateInventoryForFloorPlans(
                              projectId,
                              selectedWing,
                              floor.floorNo,
                              newFloorPlan.data[0].floorPlanId
                            )
                              .then((updateInventoryResp) => {
                                flag = true;
                                if (count === allFloors.length && flag) {
                                  returnRes(true);
                                  handleClose();
                                  successTost("Assign floor plan successfully");
                                } else {
                                  errorTost("Error While assigning floor plan");
                                }
                              })
                              .catch((errWhileUpdatingInventory) => {
                                console.log(errWhileUpdatingInventory);
                                flag = false;
                              });
                          }
                        });
                        console.log(count, allFloors.length);
                      
                      })
                      .catch((errWhileUpdatingFloorPlanImage) => {
                        console.log({ errWhileUpdatingFloorPlanImage });
                      });
                  })
                  .catch((errWhileUploadingFloorPlanImage) => {
                    console.log({ errWhileUploadingFloorPlanImage });
                  });
              })
              .catch((errWhileConvertingImage) => {
                console.log({ errWhileConvertingImage });
              });
          })
          .catch((errWhileAddingFloorPlan) => {
            console.log({ errWhileAddingFloorPlan });
          });
        }else{
          offlineToast();
        }});
      }
    }
    // ??Modal type Edit
    else if (modalType === "edit") {
      if (checkIfNoneIsSelected.length === 0) {
        errorTost("Please Select Floor");
      }else{
        if(uploadedFile){
          Network.getStatus().then((status) => {
            if (status.connected) {
          convertImageFileToWebpFile(uploadedFile).then((file) => {
            console.log(file);
            uploadFloorPlanImg(floorPlanData.floorPlanId, file)
              .then((res) => {
                console.log("res", res);
                returnRes(true);
                // let floorPlanImageUrl = `floorplans/${newFloorPlan.data[0].floorPlanId}.webp`;
              })
              .catch((errWhileConvertingImage) => {
                console.log({ errWhileConvertingImage });
              });
          });
        }else{
          offlineToast();
        }});
        }
      
        updateInventoryTable();
        updateFloorPlanFun();
      }
     
    }

    function updateInventoryTable() {
      // ??Updating Inventory table
      // ??Update On Inventory table update floorPlanId
      let flag = false;
      let count = 0;
      Network.getStatus().then((status) => {
        if (status.connected) {
      allFloors.forEach((floor) => {
        flag = true;
        count = count + 1;
        if (floor.isSelected) {
          console.log(floor);
          updateInventoryForFloorPlans(
            projectId,
            selectedWing,
            floor.floorNo,
            floorPlanData.floorPlanId
          )
            .then((updateInventoryResp) => {})
            .catch((errWhileUpdatingInventory) => {
              console.log(errWhileUpdatingInventory);
              flag = false;
            });
        } else {
          updateInventoryForFloorPlans(projectId, selectedWing, floor.floorNo, null)
            .then((updateInventoryResp) => {
              
            })
            .catch((errWhileUpdatingInventory) => {
              console.log(errWhileUpdatingInventory);
              flag = false;
            });
        }
      });
    }else{
      offlineToast();
    }});
      console.log(count, allFloors.length);
      if (count === allFloors.length && flag) {
        returnRes(true);
        handleClose();
        successTost("Assign floor plan successfully");
      } else {
        errorTost("Error While assigning floor plan");
      }
    }
    function updateFloorPlanFun() {
      // ??Update FloorPlan
      Network.getStatus().then((status) => {
        if (status.connected) {
      updateFloorPlan(floorPlanData.floorPlanId, { name: floorPlanObj.name })
        .then((r) => {
          console.log("r", r);
          returnRes(true);
        })
        .catch((errWhileUpdatingFloorPlanData) => {
          console.log({ errWhileUpdatingFloorPlanData });
        });
      }else{
        offlineToast();
      }});
    }
  }
  function getFloors(projectId, wingId) {
    Network.getStatus().then((status) => {
      if (status.connected) {
    getFloorByWingIdAndProjectId(projectId, wingId)
      .then((resp) => {
        console.log(resp);
        // ??Without selcted floor plan get those units first
        // let withoutSelectedFloorPlan=resp.data.filter(({floorPlanId})=>floorPlanId!==null);
        resp.data.forEach((each) => {
          if (each.floorPlanId === null) {
            each.isSelected = false;
            each.showCheckBox = true;
          } else {
            each.showCheckBox = false;
          }
        });
        // resp.data = resp.data.map((floor) => ({ ...floor, isSelected: false }));
        // ??For future case floor wise assigning
        // let Floors = chain(resp.data)
        //   .groupBy("floorNo")
        //   .map((value, key) => ({ floor: key, floorArr: value }))
        //   .value();
        // console.log(Floors);
        setAllFloors(uniqBy(sortBy([...resp.data], "floorNo"), "floorNo"));
      })
      .catch((err) => {
        console.log(err);
      });
    }else{
      offlineToast();
    }});
  }

  return (
    <Modal
      open={open}
      onClose={(_, reason) => {
        if (reason !== "backdropClick") {
          closeModal();
        }
      }}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
      sx={[
        {
          ".MuiBackdrop-root": {
            background: "rgba(52, 64, 84, 0.7)",
          },
        },
      ]}
      disableAutoFocus={true}
    >
      <Box className={cssClasses.modalWrapper}>
        <div className={cssClasses.wrapperHeader}>
          <span
            className={classes.closeIconModal}
            onClick={closeModal}
            tabIndex={0}
          >
            <Close width={"1.2rem"} height={"1.2rem"} />
          </span>
          {modalType==='add'?<div>Assign Floor Plan</div>:<div>Edit Floor Plan</div>}
          
        </div>
        <div className={cssClasses.wrapperContent}>
          <div style={{margin:"2rem"}}>
          <ProgressBar steps={steps} activeStep={activeStep} />
          {activeStep === 0 && (
            <div className={cssClasses.wrapperCreateFloorPlan}>
              <div className={cssClasses.leftWrapper}>
                <div className={cssClasses.section}>
                  <div className={cssClasses.input} style={{marginTop:"1rem"}}>
                    <CustomInput
                      label={"Plan Name"}
                      mandatory={true}
                      helperText={helperText.name}
                      value={floorPlanObj.name}
                      placeholder={"Enter floor plan name"}
                      handleChange={(e) => {
                        e = e.trimStart();
                        var alphabet = /^[A-Z*\sa-z]*$/;
                        if (e.match(alphabet) || e === "") {
                        setFloorPlanObj((pre) => {
                          pre.name = e;
                          return { ...pre };
                        });
                      }
                        setHelperText((pre) => {
                          if (floorPlanObj.name !== "") {
                            pre.name = "";
                          } else {
                            pre.name = "Please enter floor plan name";
                          }
                          return { ...pre };
                        });
                      }}
                    />
                  </div>
                </div>
              </div>
              <div className={cssClasses.rightWrapper}>
                <div className={cssClasses.uploadWrapper} style={{marginBottom:'2rem'}}>
                  <div className={cssClasses.label}>
                    <p>
                      Upload Floor Plan Image{" "}
                      <span style={{ color: "red" }}>*</span>
                    </p>
                  </div>
                  <div
                    className={cssClasses.upload}
                    onClick={() => {
                      document.getElementById("imgupload").click();
                    }}
                  >
                    {floorPlanObj.floorPlanImageUrl || uploadedFile ? (
                      <div className={cssClasses.uploadInputImg}>
                        <img
                          className={cssClasses.uploadedImg}
                          id="floorImg"
                          src={
                            floorPlanObj.floorPlanImageUrl
                              ? process.env.REACT_APP_SUPABASE_BUCKET_PREFIX +
                                floorPlanObj.floorPlanImageUrl +
                                `?${Date.now()}`
                              : ""
                          }
                          alt=""
                        />
                        <input
                          hidden
                          type="file"
                          accept="image/*"
                          id="imgupload"
                          name=""
                          onChange={(e) => {
                            setUploadedFile(e.target.files[0]);
                          }}
                        />
                        {/* Small icon upload image here */}
                        <div className={cssClasses.reupload}>
                          <div className={cssClasses.uploadImg1}>
                            <img src={galleryImg} alt="" />
                          </div>
                          <div className={cssClasses.uplaodLabel1}>
                            <p>Upload here</p>
                          </div>
                        </div>
                      </div>
                    ) : (
                      <div className={cssClasses.uploadInput}>
                        <div className={cssClasses.uploadImg}>
                          <img src={galleryImg} alt="" />
                        </div>
                        <div className={cssClasses.uplaodLabel}>
                          <p>Upload here</p>
                        </div>
                        <input
                          hidden
                          type="file"
                          accept="image/*"
                          id="imgupload"
                          name=""
                          onChange={(e) => {
                            setUploadedFile(e.target.files[0]);
                            setHelperText((pre) => {
                              pre.floorPlanImageUrl = "";
                              return { ...pre };
                            });
                          }}
                        />
                      </div>
                    )}
                  </div>
                  <p
                    style={{
                      color: "red",
                      fontSize: "1.4rem",
                      fontFamily: "Inter-Medium",
                      marginTop: "0.5rem",
                    }}
                  >
                    {helperText.floorPlanImageUrl}
                  </p>
                </div>
              </div>
            </div>
          )}
          {activeStep === 1 && (
            <div className={cssClasses.wrapperAssignUnit}>
              <div className={cssClasses.wrapperBlock}>
                <div className={cssClasses.blockLabel}>
                  Select Wing :<span style={{ color: "red" }}> *</span>
                </div>
                <div style={{ width: "50%" }}>
                  <DropDown
                    list={allWings.map((element, id) => {
                      return {
                        label: element.wingName,
                        value: element.wingId,
                      };
                    })}
                    selectedValue={selectedWing}
                    onChangeSelect={(value) => {
                      setSelectedWing(value);
                      getFloors(projectId, value);
                      setHelperText((pre) => {
                        pre.selectWing = "";
                        return { ...pre };
                      });
                    }}
                    placeHolder={"Select"}
                    style={{
                      background: "#F2F4F7",
                      color: "rgb(102, 112, 133)",
                    }}
                    helperText={helperText.selectWing}
                  />
                </div>
              </div>
              {selectedWing && (
                <div className={cssClasses.wrapperBlock}>
                  <div className={cssClasses.blockLabel}>
                    Select Floor :<span style={{ color: "red" }}> *</span>
                  </div>
                  {allFloors.map((floor, index) => {
                    return (
                      <FloorBlock
                        floorNo={floor.floorNo}
                        planName={floor?.floorPlanId?.name}
                        style={{ background: "#F2F4F7" }}
                        CheckBox={floor?.showCheckBox}
                        isSelected={floor?.isSelected}
                        handleChange={(e) => {
                          console.log(e.target.checked);
                          setAllFloors((pre) => {
                            pre[index].isSelected = e.target.checked;
                            return [...pre];
                          });
                        }}
                      />
                    );
                  })}
                </div>
              )}
            </div>
          )}
          </div>
         
        </div>
        <div className={cssClasses.wrapperFooter}>
          <div>
            <Button
              style={{
                color: "#344054",
                backgroundColor: "#ffffff",
                fontSize: "1.6rem",
                lineHeight: "2.4rem",
              }}
              btnName={activeStep === 0 ? "Cancel" : "Previous"}
              clicked={() => {
                if (activeStep === 0) {
                  closeModal();
                } else {
                  setActiveStep(activeStep - 1);
                }
              }}
            />
          </div>
          <div>
            <Button
              style={{
                color: "#ffffff",
                backgroundColor: "#155EEF",
                fontSize: "1.6rem",
                lineHeight: "2.4rem",
              }}
              btnName={
                activeStep === 0
                  ? "Next"
                  : modalType === "add"
                  ? "Save"
                  : "Update"
              }
              clicked={() => {
                if (activeStep === 0) {
                  let flag = validateCreateFloorPlan();
                  if (flag === 0) {
                    setActiveStep(activeStep + 1);
                  }
                } else if (activeStep === 1) {
                  save();
                }
              }}
            />
          </div>
        </div>
      </Box>
    </Modal>
  );
}
